import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { NavigationDetail } from 'app/components/Navigation/core/types';

import isNumber from 'lodash/isNumber';

import queryString from 'query-string';

export const useTab = (
  queryToTabMap: Record<string, number>,
  tabToQueryMap: Record<number, string>,
  navigationLocation: NavigationDetail[],
) => {
  const location = useLocation();
  const navigate = useNavigate();

  const query = queryString.parse(location.search);
  const tabQuery = query.tab as string;

  const [tab, setTab] = useState<number>(() => {
    const mappedTab = queryToTabMap[tabQuery];
    return isNumber(mappedTab) ? mappedTab : 0;
  });

  useEffect(() => {
    const mappedTab = queryToTabMap[tabQuery];

    if (isNumber(mappedTab)) {
      setTab(mappedTab);
      return;
    }

    navigate(`?tab=${tabToQueryMap[0]}`);
  }, [tabQuery]);

  const currentTab = useMemo(
    () => navigationLocation.find((nav) => nav.value === tab),
    [navigationLocation, tab],
  );

  const handleChangeNavigation = useCallback(
    (newValue: number) => () => {
      const queryValue = tabToQueryMap[newValue] ?? String(newValue);
      navigate(`?tab=${queryValue}`);
    },
    [navigate, tabToQueryMap],
  );

  return { tab, currentTab, handleChangeNavigation };
};
